const AGENT_URL = process.env.REACT_APP_AI_URL_QUERY;
const AGENT_RECOM_URL = process.env.REACT_APP_AI_URL;

export async function detectIntent({ message, authToken, customerId, sessionId }) {
  const url = `${AGENT_URL}/chat/detect-intent`;
  const payload = {
    message,
    auth_token: authToken,
    cust_id: customerId,
    session_id: sessionId
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  return response.json();
}


export async function fetchLocations({ authToken , customerId}) {
 const params = new URLSearchParams({ auth_token: authToken });
 
 const url = `${AGENT_URL}/get-locations?${params.toString()}&cust_id=${customerId}`;

 console.log("[fetchLocations] Fetching locations from:", url);

 const response = await fetch(url, {
  method: "GET",
  headers: {
   "Accept": "application/json",
  },
 });

 if (!response.ok) {
  console.error("[fetchLocations] API error status:", response.status);
  throw new Error(`API error: ${response.status}`);
 }

 const data = await response.json();
 console.log("[fetchLocations] API response data:", data);

 return data;
}





export async function fetchVendorsForLocation({ location, authToken, customerId }) {
  const locationQuery = Array.isArray(location) ? location.join(",") : location;
  const params = new URLSearchParams({
    location_names: locationQuery,
    auth_token: authToken,
  });
  const url = `${AGENT_URL}/get-vendors-for-location?${params.toString()}&cust_id=${customerId}`;

  const response = await fetch(url, {
    method: "GET",
    headers: { "Accept": "application/json" },
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  const data = await response.json();
  return data.vendors || [];
}


export async function fetchLocationForVendor({ vendor, authToken, customerId }) {
  const params = new URLSearchParams({
    vendor_name: vendor,
    auth_token: authToken,
  });
  const url = `${AGENT_URL}/get-locations-for-vendor?${params.toString()}&cust_id=${customerId}`;

  const response = await fetch(url, {
    method: "GET",
    headers: { "Accept": "application/json" },
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  const data = await response.json();
  return data.locations || [];
}


export async function processQueryWithEnhancedContext({
  query,
  customerId,  
  authToken,    
  locations,
  vendors,
  timePeriod,   
}) {
  const url = `${AGENT_URL}/process-query-with-enhanced-context`;
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query,
      cust_id: customerId,      
      auth_token: authToken,
      locations,
      vendors,
      time_period: timePeriod
    })
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function analyzeVisualization({ query, sqlQuery, csvData, customerId, authToken }) {
  const url = `${AGENT_URL}/analyze-visualization`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query,              
      sql_query: sqlQuery, 
      csv_data: csvData, 
      customer_id: customerId,
      auth_token: authToken
    })
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function fetchCustomerById({ customerId, authToken }) {
  const params = new URLSearchParams({
    auth_key: authToken,
  });
  const url = `${AGENT_RECOM_URL}/customer/${customerId}?${params.toString()}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return  response.json();
}

export async function analyzeBandwidth({
  location,         // string
  customer,         // string or number
  circuitId,        // string
  startDate,        // number (epoch seconds)
  endDate,          // number (epoch seconds)
  responseFormat,
  authKey
}) {
  const url = `${AGENT_RECOM_URL}/analyze-bandwidth`;

  const payload = {
    location,
    customer,                      
    circuit_id: circuitId,          
    start_date: startDate,
    end_date: endDate,
    response_format: responseFormat,
    auth_key: authKey
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  return response.json();
}

export async function sendFeedback({ feedbackType, userInput, enhancedQuery, aiSqlQuery, feedbackText, authToken }) {
  const payload = {
   "feedback_type": feedbackType,
        "user_input": userInput,
        "enhanced_query": enhancedQuery,
        "ai_sql_query": aiSqlQuery,
        "feedback_text": feedbackText,
        "auth_token": "Fil0ff56@9090"
  };
  const response = await fetch(`${AGENT_URL}/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    throw new Error(`Feedback API error: ${response.status}`);
  }
  return response.json();
}
